import { APP } from "./app.js";
const APP_EVENTS_CHANNEL = `${APP.name}:events`;
const APP_EVENTS = {
  // Constructor
  ConstructorReadyToRender: "constructor_ready_to_render",
  // Filters & Sorting
  FiltersReady: "filters_ready",
  FilterValueChanged: "filter_value_changed",
  SortValueChanged: "sort_value_changed",
  // Misc
  ComparisonViewChanged: "comparison_view_changed",
  ButtonClicked: "button_clicked",
  // Model
  ModelTileSelected: "model_tile_selected",
  ModelTileCheckboxClicked: "model_tile_checkbox_clicked",
  // Car
  CarTileSelected: "car_tile_selected"
};
const APP_EVENT_BUTTON_IDS = {
  // Filters
  RESET_FILTERS: "reset-filters-button",
  // Calculators
  OPEN_CREDIT_INSTOCK: "open-credit-instock-button",
  OPEN_TRADE_IN_INSTOCK: "open-trade-in-instock-button",
  // Comparison
  ADD_TO_COMPARISON: "add-to-comparison-button",
  REMOVE_FROM_COMPARISON: "remove-from-comparison-button",
  REMOVE_ALL_FROM_COMPARISON: "remove-all-from-comparison-button",
  // Favorites
  ADD_TO_FAVORITES: "add-to-favorites-button",
  REMOVE_FROM_FAVORITES: "remove-from-favorites-button",
  REMOVE_ALL_FROM_FAVORITES: "remove-all-from-favorites-button",
  // Back to list
  BACK_TO_LIST_FROM_CAR_PAGE: "back-to-list-from-car-page-button",
  BACK_TO_LIST_FROM_FAVORITES_PAGE: "back-to-list-from-favorites-page-button",
  BACK_TO_LIST_FROM_COMPARISON_PAGE: "back-to-list-from-comparison-page-button",
  // Booking Request
  BOOKING_FROM_CAR_PAGE: "booking-from-car-page-button",
  BOOKING_FROM_COMPARISON_PAGE: "booking-from-comparison-page-button",
  // Models
  SHOW_MODELS: "show-models-button",
  SHOW_ALL_MODELS: "show-all-models-button"
};
export {
  APP_EVENTS,
  APP_EVENTS_CHANNEL,
  APP_EVENT_BUTTON_IDS
};
